<template>
  <div class="page">
    <CContainer>
      <div class="header-bar">
        <CButton class="back-btn" aria-label="Go back" @click="$router.go(-1)">
          <svg viewBox="0 0 24 24" class="icon-back">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </CButton>
        <h2 class="center-title">Profile</h2>
      </div>

      <div class="hero">
        <div class="avatar-wrap">
          <img
            v-if="!filePath"
            class="avatar"
            src="../assets/img/DefaultUser.png"
          />
          <img v-else class="avatar" :src="filePath" />
          <button class="edit-badge" @click="triggerFileInput">
            <svg viewBox="0 0 24 24" class="icon-pen">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
              <path
                d="M20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"
              />
            </svg>
          </button>
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            @change="onFileChange"
            class="hidden-input"
          />
        </div>
        <div class="upload-title">Upload Profile Photo</div>
        <div class="upload-sub">
          Upload Profile Photo PNG, JPG<br />Max 10mb.
        </div>
      </div>

      <div class="form">
        <label class="label">Full Name</label>
        <input class="input" type="text" v-model="FullName" />

        <label class="label">Email</label>
        <input class="input" type="text" v-model="Email" disabled />

        <label class="label">Phone Number</label>
        <input class="input" type="text" v-model="PhoneNumber" />
      </div>

      <div class="text-center">
        <CButton
          class="update-btn w-100"
          color="primary"
          @click="UpdateProfile"
          block
          >Update</CButton
        >
      </div>

      <div v-if="isPopupSuccess" class="popup">
        <div class="sheet">
          <img src="../assets/img/successPopup.png" class="ok-img" />
          <h3 class="ok-title">Save Successfully</h3>
          <CButton class="ok-btn" @click="closeSuccess">OK</CButton>
        </div>
      </div>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "ProfilePage",
  data() {
    return {
      filePath: "",
      selectedFile: null,
      FullName: "",
      Email: "",
      PhoneNumber: "",
      UserId: "",
      isPopupSuccess: false,
    };
  },
  async mounted() {
    try {
      const isAuth = await this.UserAuth();
      if (isAuth) this.GetInfoUser();
      else this.GoToLogin();
      if (isAuth) {
        const canStay = await this.GetInfoUser();
        if (!canStay) return;
      } else this.GoToLogin();
    } catch (e) {
      this.GoToLogin?.();
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files?.[0];
      if (!file) return;
      this.selectedFile = file;
      const r = new FileReader();
      r.onload = (ev) => (this.filePath = ev.target.result);
      r.readAsDataURL(file);
      this.submitProfilePicture();
    },
    async submitProfilePicture() {
      if (!this.selectedFile) return;
      const fd = new FormData();
      fd.append("file", this.selectedFile);
      fd.append("userId", this.UserId);
      try {
        await this.$API.post(this.$UploadProfilePhoto, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        this.isPopupSuccess = true;
      } catch {}
    },
    async GetInfoUser() {
      try {
        const res = await this.$API.get(this.$LoginUserDetail, {
          withCredentials: true,
        });
        if (res.status === 200 && res.data) {
          const u = res.data;
          this.filePath = u.filePath || "";
          this.FullName = u.name || "";
          this.Email = u.email || "";
          this.PhoneNumber = u.phone || "";
          this.UserId = u.id || "";

          if (this.isDefaultUserEmail(u.email)) {
            await this.logoutDefaultUser();
            return false;
          }

          return true;
        }
      } catch {}
      return false;
    },
    isDefaultUserEmail(email) {
      return (email || "").toLowerCase() === "defaultuser@gmail.com";
    },
    async logoutDefaultUser() {
      try {
        await this.$API.get(this.$SignOut, { withCredentials: true });
      } catch (e) {
        // ignore sign-out failures; we still redirect
      } finally {
        this.$router.push("/Login");
      }
    },
    GoToLogin() {
      const path = this.$router.currentRoute.path;
      if (path.toLowerCase() !== "/login") {
        this.$router.push({
          path: "/Login",
          query: { targetUrl: this.$router.currentRoute.fullPath },
        });
      }
    },
    async UpdateProfile() {
      const fd = new FormData();
      fd.append("fullName", this.FullName);
      fd.append("phoneNumber", this.PhoneNumber);
      try {
        const r = await this.$API.post(this.$UserDetails, fd, {
          withCredentials: true,
        });
        if (r.status === 200 && r.data?.status !== 400) {
          this.isPopupSuccess = true;
          this.GetInfoUser();
        }
      } catch {}
    },
    closeSuccess() {
      this.isPopupSuccess = false;
    },
  },
};
</script>

<style scoped>
.page {
  background: #fff;
  min-height: 100vh;
  padding-bottom: 24px;
}
.header-bar {
  position: relative;
  height: 75px;
  margin-bottom: 8px;
}
.back-btn {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: #111827;
  cursor: pointer;
}
.icon-back {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.center-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}
.hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 8px;
}
.avatar-wrap {
  position: relative;
  width: 120px;
  height: 120px;
}
.avatar {
  width: 120px;
  height: 120px;
  border-radius: 999px;
  object-fit: cover;
}
.edit-badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #928afd;
  border: 4px solid #fff;
  display: grid;
  place-items: center;
  color: #fff;
  cursor: pointer;
}
.icon-pen {
  width: 18px;
  height: 18px;
  fill: #fff;
}
.hidden-input {
  display: none;
}
.upload-title {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}
.upload-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.3;
}
.form {
  margin-top: 28px;
}
.label {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #171717;
  margin-bottom: 6px;
}
.input {
  width: 100%;
  height: 44px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 14px;
  color: #171717;
  background: #fff;
  margin-bottom: 14px;
}
.input:disabled {
  color: #6b7280;
  background: #f9fafb;
}
.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 12px;
  padding: 0 16px;
}
.update-btn {
  border-radius: 999px;
  height: 48px;
  width: 100%;
  background: #928afd;
  border-color: #928afd;
  font-weight: 700;
}
.popup {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: flex-end;
  z-index: 999;
}
.sheet {
  width: 100%;
  max-width: 520px;
  margin: 0 auto 16px;
  background: #fff;
  border-radius: 18px;
  padding: 16px;
  text-align: center;
}
.ok-img {
  max-width: 280px;
  margin: 8px auto;
}
.ok-title {
  font-size: 20px;
  color: #171717;
  margin: 8px 0;
}
.ok-btn {
  border-radius: 12px;
  margin-top: 8px;
}
</style>
